"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
import { ladeDropdownApi } from "../topbar/preline-dropdown";

/**
 * Schließt das Konto-Menü bei Auswahl und bei Routenwechsel. Ursache des „stehenbleibenden“ Menüs: die Hülle trägt
 * `--auto-close:inside` (Untermenüs sollen beim Öffnen offen bleiben), Preline schließt dann bei keinem Klick innen, und
 * Next.js navigiert clientseitig, ohne dass die Hülle neu aufgebaut wird. Dieser Wächter sitzt unsichtbar in der Hülle:
 * ein Klick auf einen Link oder eine Taste der Menü-Einträge (nicht auf den Öffner eines Untermenüs) und jeder neue Pfad
 * schließen die Hülle über die Preline-API (`HSDropdown.close`, derselbe Weg wie beim Tour-Start in `tour-wahl.tsx`).
 */
export function KontoSchliesser() {
  const marke = useRef<HTMLSpanElement>(null);
  const pfad = usePathname();
  const erster = useRef(true);

  const schliesse = () => {
    const huelle = marke.current?.closest<HTMLElement>(".hs-dropdown");
    if (!huelle || !huelle.classList.contains("open")) return;
    void ladeDropdownApi()
      .then((api) => api.close(huelle))
      .catch(() => {
        // Preline nicht verfügbar: das Menü bleibt offen, Navigation und Aktion laufen trotzdem.
      });
  };

  useEffect(() => {
    if (erster.current) {
      erster.current = false;
      return;
    }
    schliesse();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- nur der Pfad löst aus
  }, [pfad]);

  useEffect(() => {
    const huelle = marke.current?.closest<HTMLElement>(".hs-dropdown");
    if (!huelle) return;
    const beiKlick = (e: MouseEvent) => {
      const ziel = e.target instanceof Element ? e.target : null;
      if (!ziel || !ziel.closest(".hs-dropdown-menu")) return;
      const eintrag = ziel.closest("a[href], button");
      if (!eintrag || eintrag.classList.contains("hs-dropdown-toggle")) return;
      schliesse();
    };
    huelle.addEventListener("click", beiKlick);
    return () => huelle.removeEventListener("click", beiKlick);
  }, []);

  return (
    <>
      {/* Preline: ui-components/ui-components-sub-menus-selection/ui-components-cat-account-and-workspace-menus/account-menu-with-status-controls (Verhalten: Schließen über HSDropdown.close; unsichtbare Marke) */}
      <span ref={marke} hidden aria-hidden="true" />
    </>
  );
}
